import { queryOptions } from '@tanstack/react-query'
import { catalogKeys } from './keys'
import { CACHE_TIMES } from './cache-config'
import { studentCatalogApi } from '@/lib/api/student-catalog'

export function categoriesQueryOptions(params?: { menuId?: string; menuSlug?: string }) {
  return queryOptions({
    queryKey: catalogKeys.categories(params),
    queryFn: async () => {
      const { data, error } = await studentCatalogApi().api.student.catalog.categories.get({ query: params })
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_LIST,
  })
}

export function coursesByCategoryQueryOptions(categoryId: string) {
  return queryOptions({
    queryKey: catalogKeys.courses(categoryId),
    queryFn: async () => {
      const { data, error } = await studentCatalogApi().api.student.catalog.courses({ categoryId }).get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_LIST,
    enabled: !!categoryId,
  })
}

export function courseDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: catalogKeys.courseDetail(id),
    queryFn: async () => {
      const { data, error } = await studentCatalogApi().api.student.catalog.course({ id }).get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_DETAIL,
    enabled: !!id,
  })
}

export function searchCoursesQueryOptions(params?: Record<string, unknown>) {
  return queryOptions({
    queryKey: catalogKeys.search(params),
    queryFn: async () => {
      const { data, error } = await studentCatalogApi().api.student.catalog.search.get({ query: params })
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_FILTERED,
  })
}

export function resolveSlugQueryOptions(slug: string) {
  return queryOptions({
    queryKey: catalogKeys.resolve(slug),
    queryFn: async () => {
      const { data, error } = await studentCatalogApi().api.student.catalog.resolve({ slug }).get()
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_STATIC,
    enabled: !!slug,
  })
}
